import React, { useMemo } from 'react'

import Image from 'next/image'

import BellSlash from '@/assets/img/bell-slash.svg'
import { User } from '@/types/unlock'
import { getUserGroup } from '@/utils/userGroups'

type AvatarProps = {
  user?: User
  radius?: number
  onClick?: VoidFunction
  color?: string
  text?: string
  textColor?: string
}

const Avatar = (props: AvatarProps) => {
  const { user, onClick, color, text = null, radius = 30, textColor = '#fff' } = props

  const initials = useMemo(() => {
    let fullNameList: string[]

    if (!user?.first_name) {
      fullNameList = [user?.email]
    } else {
      fullNameList = [user?.first_name, user?.last_name]
    }

    let dealMemberInitials = fullNameList.reduce((previousValue, currentValue) => {
      return previousValue + (!currentValue ? '' : currentValue[0])
    }, '')

    dealMemberInitials = dealMemberInitials || 'A'

    return dealMemberInitials.toUpperCase()
  }, [user])

  const getAvatarColor = () => {
    if (color) return color
    return getUserGroup(user)?.color || '#21130d'
  }

  const isUserOutOfOffice = user?.data?.out_of_office ?? false

  const isUserMaximus = user?.first_name.toLowerCase().includes('maximus')

  return (
    <div
      title={user?.data?.full_name || user?.email}
      className='flex items-center justify-center p-px text-xs font-bold text-white bg-black rounded-full z-0 border border-white relative'
      onClick={onClick}
      style={{
        minWidth: radius,
        minHeight: radius,
        backgroundColor: getAvatarColor(),
        color: textColor,
      }}
    >
      {!isUserMaximus && isUserOutOfOffice && (
        <Image
          src={BellSlash}
          alt='Out of office'
          className='absolute -top-1 -right-1 w-4 h-4 bg-white rounded-full shadow'
        />
      )}
      <p>{text ? text : initials}</p>
    </div>
  )
}

export default Avatar
